<!-- using flex-row-reverse so icon can display on hover -->
<div class="w-fit">
  <div class="group flex flex-row-reverse">
    <div class="address-details">
      @if (address()?.addressee) {
        <p>{{ address()?.addressee }}</p>
      }
      @if (address()?.attention) {
        <p>Attn: {{ address()?.attention }}</p>
      }
      @if (address()?.address1) {
        <p>{{ address()?.address1 }}</p>
      }
      @if (address()?.address2) {
        <p>{{ address()?.address2 }}</p>
      }
      @if (address()?.city || address()?.state || address()?.zipCode) {
        <p>
          @if (address()?.city) {
            <span>{{ address()?.city }}, </span>
          }
          @if (address()?.state) {
            <span>{{ address()?.state }} </span>
          }
          @if (address()?.zipCode) {
            <span>{{ address()?.zipCode }}</span>
          }
        </p>
      }
    </div>
    @if (enableCopyButton()) {
      <button
        mat-icon-button
        type="button"
        class="group-hover:block ml-[-38.5px]"
        [class.hidden]="onHover()"
        (click)="copyToClipboard()"
        aria-label="Copy address to clipboard"
      ><mat-icon fontSet="material-symbols-outlined">content_paste</mat-icon></button>
    }
  </div>
</div>
